import React from 'react';
import { Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import NavBar from './NavBar';
import defaultLogo from './../../images/logo.png';
import qualfonLogo from './../../images/qualfon-logo.png';

const Header = () => {
  const location = useLocation();

  // Use qualfonLogo on /ccpa-form, otherwise defaultLogo
  const isQualfon = location.pathname === '/ccpa-form';
  const logo = isQualfon ? qualfonLogo : defaultLogo;

  return (
    <Container fluid className="w-100 header">
      <div></div>
      <div className="d-flex justify-content-between text-center w-100">
        <Link to="/">
           <img 
             src={logo} 
             alt="logo" 
             className={`logo ${isQualfon ? 'qualfon-logo' : ''}`} 
           />
        </Link>
        <NavBar />
      </div>
    </Container>
  );
};

export default Header;
